// extracted by mini-css-extract-plugin
export default {"wrapper":"topStudents_wrapper__IeNnt","title":"topStudents_title__isvkt"};